export enum CookieEnum {
  StripeCoupon = 'StripeCoupon',
  Experiment = 'Experiment',
}
